import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { BillingValorization } from "../../../model/billing/billing-order-control";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { BillingOrdenControlWizardService } from "../../../services/billing/billing-orden-control-wizard.service";
import { WizardStep } from "../../../wizard/wizard.component";
import { ValidateValorizationEdit } from "../../../validators/valorization-edit.validator";
import { ValorizationService } from "src/app/services/valorization/valorization.service";
import { debounceTime, tap } from "rxjs/operators";

@Component({
  selector: "app-billing-orden-control-valorization",
  templateUrl: "./billing-orden-control-valorization.component.html",
  styleUrls: ["./billing-orden-control-valorization.component.css"],
})
export class BillingOrdenControlValorizationComponent
  implements OnInit, WizardStep
{
  isInit: boolean;
  formGroup: FormGroup;
  loadingInit: boolean;
  loading: boolean;
  isRegistered: boolean;
  isDisabled: boolean = false;
  editableAgreementPriceIds: number[] = [];
  private hasPendingChanges: boolean = false;

  constructor(
    private billingOrdenControlWizardService: BillingOrdenControlWizardService,
    private notificationToastService: NotificationToastService,
    private valorizationService: ValorizationService,
    private formBuilder: FormBuilder
  ) {
    this.formGroup = this.formBuilder.group({
      ValorizationEdit: [null, [Validators.required, ValidateValorizationEdit]],
    });

    this.formGroup.valueChanges
      .pipe(
        tap(() => (this.hasPendingChanges = true)),
        debounceTime(2000)
      )
      .subscribe(() => {
        this.billingOrdenControlWizardService.setBillingValorization(
          <BillingValorization>this.formGroup.getRawValue()
        );
        this.hasPendingChanges = false;
      });
  }

  get f() {
    return this.formGroup.controls;
  }
  get completed(): boolean {
    return !this.formGroup.invalid && !this.hasPendingChanges;
  }

  save() {}

  async activate() {
    await this.setValorizationValidation();
  }

  private async setValorizationValidation() {
    try {
      let billingValorization = <BillingValorization>(
        this.formGroup.getRawValue()
      );

      const noEditprocedures =
        billingValorization.ValorizationEdit.ValorizationAmount.ValorizationItemsAmount.filter(
          (v) =>
            !v.ValorizationItem.MedicalAppointmentProcedure.CanEditValoization
        ).map((v) => v.ValorizationItem.MedicalAppointmentProcedure);

      if (noEditprocedures.length > 0) {
        this.isDisabled = true;
      }

      const agreementPriceIds =
        billingValorization.ValorizationEdit.ValorizationAmount.ValorizationItemsAmount.filter(
          (v) => v.ValorizationItem.AgreementPriceId
        ).map((v) => v.ValorizationItem.AgreementPriceId);

      const valorizationValidation =
        await this.valorizationService.getValorizacionValidation(
          this.billingOrdenControlWizardService.getMedicalAppointmentId(),
          agreementPriceIds
        );
      this.isRegistered = valorizationValidation.RegisteredProcedures;
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    }
  }

  get valid(): boolean {
    return this.completed;
  }

  getTransactionReferenceMessage(): string {
    return (
      " " +
      this.billingOrdenControlWizardService.getTransactionReferenceMessage()
    );
  }

  async ngOnInit() {
    await this.loadInfo();
  }

  private async loadInfo() {
    this.loadingInit = true;
    try {
      const billingValorization =
        await this.billingOrdenControlWizardService.getBillingValorization();

      this.formGroup.patchValue({
        ValorizationEdit: billingValorization.ValorizationEdit,
      }, { emitEvent: false });
      this.billingOrdenControlWizardService.setBillingValorization(
        billingValorization
      );
      this.isInit = true;
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Control órden"
      );
    } finally {
      this.loadingInit = false;
    }
  }

  async recalculate() {
    try {
      this.loading = true;
      let billingValorization = <BillingValorization>(
        this.formGroup.getRawValue()
      );
      billingValorization =
        await this.billingOrdenControlWizardService.getRecalculatedBillingValorization(
          billingValorization
        );
      this.formGroup.patchValue({
        ValorizationEdit: billingValorization.ValorizationEdit,
      });
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Control órden"
      );
    } finally {
      this.loading = false;
    }
  }
}
